import React from 'react';
import AsyncComponent from '../../components/AsyncComponent';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import moment from 'moment-timezone';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';

import AlertsService from '../../services/AlertsService';

import Cities from '../../data/Cities';
import i18n from '../../i18n';

import { withStyles } from 'tss-react/mui';
import './styles.scss';

const LIST_LENGTH = 5;

class AlertFeed extends AsyncComponent {
  constructor(props) {
    super(props);
    this.state = {
      alerts: [],
      firstAlertIndex: 0,
      lastAlertIndex: LIST_LENGTH,
      selectedCity: '',
    };

    this.alertTypes = {};
    this.cities = [];

    this._initialize();
  }

  render() {
    return (
      <Grid size={{ xs: 12, sm: 12, md: 12 }}>
        {this._renderCitySelector()}
        {this._renderAlerts()}
        {this._renderPreviousNextButtons()}
      </Grid>
    );
  }

  async _initialize() {
    await this._getCities();
    await this._getAlertTypes();
    await this._getAlerts(this.cities.length > 0 ? this.cities[0].cityId : null);
  }

  async _getAlerts(cityId) {
    const alertResponse = await AlertsService.getAlerts(cityId);
    if (alertResponse.status === 'error')
      return;

    const alerts = alertResponse.alerts;
    alerts.sort((a, b) => {
      const x = a.time_to_send ? a.time_to_send : a.created_at;
      const y = b.time_to_send ? b.time_to_send : b.created_at;

      return x < y ? 1
        : (x > y ? -1 : 0);
    });

    await this.setStateAsync({ alerts: alerts, selectedCity: cityId });
  }

  async _getAlertTypes() {
    this.alertTypes = await AlertsService.getAlertTypes();
  }

  async _getCities() {
    this.cities = await Cities.getInstance().getCities();
  }

  _renderCitySelector() {
    const { classes } = this.props;

    return (
      <Box mt={2} className={classes.citySelectorContainer}>
        <select
          className={classes.citySelector}
          onChange={(e) => {
            this._getAlerts(e.target.value);
          }}
          value={this.state.selectedCity}
        >
          {
            this.cities.map((city) => (
              <option key={city.cityId} value={city.cityId}>{city.name}</option>
            ))
          }
        </select>
      </Box>
    );
  }

  _renderAlerts() {
    const { classes } = this.props;

    return (
      <div className={classes.alertList}>
        {
          this.state.alerts && this.state.alerts.slice(this.state.firstAlertIndex, this.state.lastAlertIndex).map((alert) => (
            this._renderOneAlert(alert)
          ))
        }
      </div>
    );
  }

  _renderOneAlert(alert) {
    const { classes } = this.props;

    return (
      <Link className={classes.alertItem} key={alert.id} to={`/alert/${alert.id}`}>
        <Typography variant="h6">{alert.title}</Typography>
        <Typography variant="body1">{this.alertTypes[alert.type] && this.alertTypes[alert.type][i18n.getLanguageEnabled()] ? this.alertTypes[alert.type][i18n.getLanguageEnabled()] : alert.type}</Typography>
        <Typography variant="body1">{moment(alert.time_to_send ? alert.time_to_send : alert.created_at).format('🕑 YYYY-MM-DD - HH:mm')}</Typography>
        <Typography variant="body1">{alert.content}</Typography>
      </Link>
    );
  }

  _renderPreviousNextButtons() {
    const { classes } = this.props;

    return (
      <Box mt={2} className={classes.previousNextButtonContainer}>
        <button
          className={classes.previousNextButton}
          onClick={() => this.setState({ firstAlertIndex: Math.max(this.state.firstAlertIndex - LIST_LENGTH, 0), lastAlertIndex: Math.max(this.state.lastAlertIndex - LIST_LENGTH, LIST_LENGTH) })}
          disabled={this.state.firstAlertIndex === 0}
        >
          {i18n.t('previous')}
        </button>
        <button
          className={classes.previousNextButton}
          onClick={() => this.setState({ firstAlertIndex: this.state.firstAlertIndex + LIST_LENGTH, lastAlertIndex: this.state.lastAlertIndex + LIST_LENGTH })}
          disabled={this.state.lastAlertIndex >= this.state.alerts.length}
        >
          {i18n.t('next')}
        </button>
      </Box>
    );
  }
}

const styles = theme => ({
  alertItem: {
    border: '1px solid #ccc',
    borderRadius: '4px',
    padding: '10px',
    marginBottom: '10px',
    width: '100%',
    textDecoration: 'none',
    color: 'inherit'
  },
  alertList: {
    border: '1px solid #333',
    borderRadius: '4px',
    padding: '10px',
    marginBottom: '10px',
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: theme.spacing(0, 4, 0, 4),
  },
  citySelector: {
    padding: '5px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
  },
  citySelectorContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  previousNextButton: {
    margin: '0 5px',
    padding: '5px 10px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    backgroundColor: '#f5f5f5',
    cursor: 'pointer',
    '&:disabled': {
      cursor: 'not-allowed',
      opacity: 0.5,
    },
  },
  previousNextButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
  },
});

export default withStyles(AlertFeed, styles);;
